<template>
	<div class="f-contact-repeater">
		<table class="st-table st-table--full">
			<tr>
				<th class="st-table__th st-table__th--position"></th>
				<th style="width: 150px;">{{ $t('Contacts: Typ') }}</th>
				<th style="width: 40px;">{{ $t('Contacts: Show') }}</th>
				<th>value</th>
			</tr>
			<draggable :element="'tbody'" v-model="value" :options="{forceFallback: true, animation: 150, handle:'.drag'}">
				<tr v-for="(contact, index) in value">
					<td class="st-table__td st-table__td--position"><i class="drag fa fa-bars"></i></td>
					<td>
						<i class="fa" :class="'fa-'+(contact.icon ? contact.icon : contact.type)"></i> {{ $t((contact.title ? contact.title : contact.type)) }}
					</td>
					<td>
						<div class="st-checkbox">
							<input :id="index+'-'+contact.type" type="checkbox" class="st-checkbox__input" v-model="contact.checked" :disabled="systemdisable" />
							<label :for="index+'-'+contact.type" class="st-checkbox__label"></label>
						</div>
					</td>
					<td>
						<input class="st-input st-input--sm st-input--full st-input--email" v-if="contact.type == 'email'" autocomplete="email" type="email" v-model="contact.value" :disabled="systemdisable"/>
						<input class="st-input st-input--sm st-input--full st-input--text" v-else type="text" autocomplete="tel" v-model="contact.value" :disabled="systemdisable" />
					</td>
				</tr>
			</draggable>
		</table>
	</div>
</template>

<script>

import help_general from '@/helpers/general';

export default {
	name: 'f-contact-repeater',
	computed: {
		systemdisable(){
			let field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},
	  	value: {
		    get () {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	field.value
		      	return field.value
		    },
		    set (value) {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	field.value = value;
		    }
		}
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},
	methods: {
		getFieldValidation: help_general.getFieldValidation,
		validate(){
			return new Promise((resolve, reject) => {
				resolve(true);
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/form/f-contact-repeater.vue